
export class LocalizationAwareError extends Error {
    constructor(public readonly localizationKey: string, errorMessage?: string) {
        super(errorMessage);
    }
}